import React from 'react'
import PropTypes from 'prop-types'

// Helpers
import { formatCurrency } from '@eig-builder/core-utils/helpers/currency-helper'

// Other
import Text from 'localize'
import './lang'

export const DiscountRow = ({ prices, currency }) => {
  const { discount = 0 } = prices

  if (!discount) {
    return (null)
  }

  return (
    <div className='row'>
      <div className='col-6'><Text message='modules.cart.components.prices.discount' /></div>
      <div className='col-6 price es-subtitle-sm'>-{formatCurrency(discount, currency)}</div>
    </div>
  )
}

DiscountRow.propTypes = {
  prices: PropTypes.object,
  currency: PropTypes.object
}

export const ShippingRow = ({ prices, currency }) => {
  return <div className='row'>
    <div className='col-6'><Text message='modules.cart.components.prices.shipping' /></div>
    <div className='col-6 price es-subtitle-sm'>
      {prices.shippingForFreeDiscount
        ? <Text message='modules.cart.components.prices.free' />
        : formatCurrency(prices.shipping, currency)}
    </div>
  </div>
}

ShippingRow.propTypes = {
  prices: PropTypes.object,
  currency: PropTypes.object
}

export const SubtotalRow = ({ prices, currency }) => {
  if ((prices.subtotalProducts !== prices.grantTotalIncl || prices.shippingForFreeDiscount || prices.discount > 0)) {
    return (
      <div className='row'>
        <div className='col-6'><Text message='modules.cart.components.prices.subtotal' /></div>
        <div className='col-6 price es-subtitle-sm'>{formatCurrency(prices.subtotalProducts, currency)}</div>
      </div>
    )
  }

  return null
}

SubtotalRow.propTypes = {
  prices: PropTypes.object,
  currency: PropTypes.object
}

export const EuropeanTaxRow = ({ prices, currency, currentTaxPercent }) => {
  const { tax = 0, fromEu = false } = prices || {}

  if (!tax || !fromEu) {
    return (null)
  }

  return (
    <>
      <div className='col-6 tax'>
        <Text message='modules.cart.components.prices.includesTaxes' />
        <span className='tax-percent'>{` (${currentTaxPercent}%)`}</span>
      </div>
      <div className='col-6 price es-subtitle-sm tax'>{formatCurrency(tax, currency)}</div>
    </>
  )
}

EuropeanTaxRow.propTypes = {
  prices: PropTypes.object,
  currency: PropTypes.object,
  currentTaxPercent: PropTypes.number
}

export const TaxRow = ({ prices, currency }) => {
  const { tax = 0, fromEu = false } = prices || {}

  if (!tax || fromEu) {
    return (null)
  }

  return (
    <div className='row'>
      <div className='col-6'><Text message='modules.cart.components.prices.tax' /></div>
      <div className='col-6 price es-subtitle-sm'>{formatCurrency(tax, currency)}</div>
    </div>
  )
}

TaxRow.propTypes = {
  prices: PropTypes.object,
  currency: PropTypes.object
}
